export default __webpack_public_path__ + "static/media/market-quiz-info.b8495bd3.png";